import request from '@/utils/request'
const BASE_URL = '/User'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  login(data) {
    return request({
      url: BASE_URL + '/Login',
      method: 'post',
      data
    })
  },
  loginByMobile(data) {
    return request({
      url: BASE_URL + '/LoginByMobile',
      method: 'post',
      data
    })
  },
  // sendCode(mobile) {
  //   return request({
  //     url: BASE_URL + '/SendCode',
  //     method: 'post',
  //     data: mobile
  //   })
  // },
  resetPwd(data) {
    return request({
      url: BASE_URL + '/ResetPwd',
      method: 'post',
      data
    })
  },
  sendCode(mobile, codeType) {
    return request({
      url: BASE_URL + '/SendCode',
      method: 'get',
      params: { mobile, codeType }
    })
  },
  logout() {
    return request({
      url: BASE_URL + '/Logout',
      method: 'post',
    })
  },
  forceLogout(data) {
    return request({
      url: BASE_URL + '/ForceLogout',
      method: 'post',
      data
    })
  },
  refreshToken(data) {
    return request({
      url: BASE_URL + '/RefreshToken',
      method: 'post',
      data
    })
  },
  getPermission() {
    return request({
      url: BASE_URL + '/GetPermission',
      method: 'post'
    })
  },
  changePwd(data) {
    return request({
      url: BASE_URL + '/ChangePwd',
      method: 'post',
      data
    })
  },
  getBgIndexInfo() {
    return request({
      url: BASE_URL + '/GetBgIndexInfo',
    })
  },
}